module.exports = __webpack_public_path__ + "static/media/img2-2.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/biosense/diff/img2-2.png
// module id = 1702
// module chunks = 3